import {
  DOCTOR_WITH_CUSTOMER_SUCCESS,
  DOCTOR_WITH_CUSTOMER_FAIL,
  DOCTOR_WITH_CUSTOMER_PENDING,
} from "../../actions/types";

const initialState = {
  doctorsWithCustomer: {
    result: [],
    totalCount: 0,
    totalPages: 0
  },
  loading: false,
};

const doctors_with_customer_reducer = (state = initialState, action) => {
  const { type, payload } = action;
  
  switch (type) {
    case DOCTOR_WITH_CUSTOMER_PENDING:
      return {
        ...state,
        loading: true,
      };
    case DOCTOR_WITH_CUSTOMER_SUCCESS:
      return {
        ...state,
        doctorsWithCustomer: {
          result: payload.doctors,
          totalCount: payload.totalCount,
          totalPages: payload.totalPages
        },
        loading: false,
      };
    case DOCTOR_WITH_CUSTOMER_FAIL:
      return {
        ...state,
        doctorsWithCustomer: {
          result: [],
          totalCount: 0,
          totalPages: 0
        },
        loading: false,
      };
    default:
      return state;
  }
};

export default doctors_with_customer_reducer;